export enum WeeklyHoursRequirement {
  SUGGESTED_AT_LEAST = 'suggested_at_least',
  SUGGESTED_AT_MAXIMUM = 'suggested_at_maximum',
  FLEXIBLE = 'flexible',
}
